import styled from 'styled-components';

const StyledContainer = styled.div`
	width: 94%;
	max-width: 55rem;
	margin: 0 auto;
`;

export { StyledContainer };
